import Service from '../Service';
import Server from './index';
import Constants from '../../submodules/logictry_config/constants';

class TreeApi extends Service {
  async getTree(id, _query = {}) {
    if (Constants.isWidget) _query.checkEmbedAuthorization = 'true';
    return Server.__getRequest(`/apps/${id}?${Object.keys(_query).map((_key) => `${_key}=${_query[_key]}`).join('&')}`, null, id);
  }
  async getCount(_query) {
    return Server.__getRequest(`/apps/count?${Object.keys(_query).map((_key) => `${_key}=${_query[_key]}`).join('&')}`);
  }
  async getAccountTrees(_query) {
    return Server.__getRequest(`/apps?${Object.keys(_query).map((_key) => `${_key}=${_query[_key]}`).join('&')}`, null, _query?._ids);
  }
  async createTree(_tree) {
    return Server.__postRequest('/apps', _tree);
  }
  async updateTree(_tree) {
    return Server.__patchRequest('/apps', _tree);
  }
  async deleteTree(id) {
    return Server.__deleteRequest(`/apps/${id}`);
  }
}

const singleton = new TreeApi();
export default singleton;
